const imagesListingMixin = portfolio => ({
  data() {
    return {
      showMasonry: false,
      masonryView: "default",
      lowResImagesLoaded: 0,
      mediumResImagesLoaded: 0,
      // galleryIndex: null,
    }
  },
  computed: {
    portfolio() {
      return this.$store.state[portfolio]
    },
    portfolioImages() {
      if (this.portfolio) {
        return this.portfolio.find((x) => x.slug === this.$route.params.category).images
      }
    },
    mediumImages() {
      let images = []

      if (this.portfolio) {
        this.portfolioImages.forEach((object) => {
          images.push(object.medium)
        })
      }

      return images
    },
    // highImages() {
    //   let images = []

    //   if (this.portfolio) {
    //     this.portfolioImages.forEach((object) => {
    //       images.push(object.high)
    //     })
    //   }

    //   return images
    // },
    masonryColumns() {
      const columnsByWidth = {
        '576': 1,
        '1200': 2,
        '1367': 3,
      };

      const columnsByWidthAlt = {
        '576': 2,
        '1200': 3,
        '1367': 3,
      };

      const columns = this.masonryView === "default" ? columnsByWidth : columnsByWidthAlt;

      let key = 1367;

      if (this.$root.viewport.width < 1200) {
        key = 1200;
      }

      if (this.$root.viewport.width < 576) {
        key = 576;
      }

      return columns[key];
    },
  },
  methods: {
    toggleMasonryColumns() {
      this.showMasonry = false

      if (!this.$root.isDevice && document.querySelector('[data-scroll-section]').style.transform !== 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)') {
        this.$root.scrollToTop(() => {
          setTimeout(() => {
            this.masonryView = this.masonryView == "default" ? "alt" : "default";
            this.showMasonry = true;
          }, 250)
        })
      } else {
        setTimeout(() => {
          this.masonryView = this.masonryView == "default" ? "alt" : "default";
          this.showMasonry = true;
        }, 250)
      }
    },
    onLowResImageLoad() {
      this.lowResImagesLoaded++
    },
    watchLowResImages() {
      const watchLowResImagesLoaded = () => {
        if (this.lowResImagesLoaded && this.lowResImagesLoaded === this.portfolioImages.length && this.$root.loaderPercentage === 100) {
          this.showMasonry = true
          this.loadMediumResImages();

          setTimeout(() => {
            this.$store.dispatch("togglePageReady", true);
          }, this.$root.loaderCountDuration - 2500);

          window.cancelAnimationFrame(watchLowResImagesLoaded);
        } else {
          this.$root.setLoaderPercentage(Math.round(this.lowResImagesLoaded / this.portfolioImages.length * 100));
          window.requestAnimationFrame(watchLowResImagesLoaded);
        }
      }

      window.requestAnimationFrame(watchLowResImagesLoaded);
    },
    loadMediumResImages() {
      let mediumResImages = document.querySelectorAll('.img-medium')
      mediumResImages.forEach((el, i) => {
        const src = el.getAttribute('data-src')
        el.setAttribute('src', src)
      })
    },
    showMediumResImage(e) {
      this.mediumResImagesLoaded++
      e.target.classList.add('show');
    },
    // goToRoute(to) {
    //   if (!this.$root.isDevice && this.$root.smoothScroller.el.firstChild.style.transform !== "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)") {
    //     this.$root.scrollToTop(() => {
    //       setTimeout(() => {
    //         this.$router.push(to)
    //       }, 1000)
    //     })
    //   } else {
    //     this.$router.push(to)
    //   }
    // },
  },
  beforeRouteUpdate(to, from, next) {
    this.lowResImagesLoaded = 0;
    this.mediumResImagesLoaded = 0;

    this.watchLowResImages();

    document.querySelectorAll('.img-medium').forEach((el, i) => {
      el.classList.remove('show')
    })

    next();
  },
  created() {
    this.watchLowResImages();
  }
})

export default imagesListingMixin